export const breakpoints = {
    values: {
        sm: 480, // Mobile
        md: 768, // Tablet
        lg: 1024, // Laptop
        xl: 1280, // Desktop
    },
};
